import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { CartContainer, EntityList } from '@aimsos/ui';

import { NOTE_KIND_ICON } from './noteKindIcons.js';

import { Bot, Lightbulb } from 'lucide-react';

/**
 * One reading of the Concierge on From notes — a summary, topics or an
 * interpretation — and where it came from (CT-5724). "Fix" and "Flag as claim"
 * are drawn by the prototype but what they do is not decided (open question 2),
 * so they are not built.
 */
const NotesFeedItem = memo(function NotesFeedItem({ note }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <div data-testid="notes-feed-item" data-note-kind={note.kind}>
      <CartContainer size="S" variant="neutral">
        <EntityList
          title={note.title ?? t(`history.notes.kinds.${note.kind}`)}
          icon={NOTE_KIND_ICON[note.kind] ?? Lightbulb}
          iconHighlight={{ bgColor: 'Purple', iconColor: 'Purple' }}
          pinned={note.kind ? { label: t(`history.notes.kinds.${note.kind}`), variant: 'neutral' } : undefined}
          description={note.text}
          secondaryMeta={note.origin ? [{ id: 'origin', icon: Bot, label: t('history.notes.origin', { origin: note.origin }) }] : undefined}
        />
      </CartContainer>
    </div>
  );
});

export default NotesFeedItem;
